var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 0H1.4C.628 0 0 .628 0 1.4v4.2C0 6.372.628 7 1.4 7h4.2C6.372 7 7 6.372 7 5.6V1.4C7 .628 6.372 0 5.6 0zM6 5.375C6 5.72 5.72 6 5.375 6h-3.75A.626.626 0 0 1 1 5.375v-3.75C1 1.28 1.28 1 1.625 1h3.75C5.72 1 6 1.28 6 1.625v3.75zM14.6 0h-4.2C9.628 0 9 .628 9 1.4v4.2c0 .772.628 1.4 1.4 1.4h4.2c.772 0 1.4-.628 1.4-1.4V1.4c0-.772-.628-1.4-1.4-1.4zm.4 5.375c0 .345-.28.625-.625.625h-3.75A.626.626 0 0 1 10 5.375v-3.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625v3.75zM5.6 9H1.4C.628 9 0 9.628 0 10.4v4.2c0 .772.628 1.4 1.4 1.4h4.2c.772 0 1.4-.628 1.4-1.4v-4.2C7 9.628 6.372 9 5.6 9zm.4 5.375c0 .345-.28.625-.625.625h-3.75A.626.626 0 0 1 1 14.375v-3.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625v3.75zM14.182 12h-1.455v-1.455a.363.363 0 1 0-.727 0V12h-1.455a.363.363 0 1 0 0 .727H12v1.455a.363.363 0 1 0 .727 0v-1.455h1.455a.363.363 0 1 0 0-.727z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppRoles);
export default __webpack_public_path__ + "static/media/appRoles.5b45c27f.svg";
export { ForwardRef as ReactComponent };